import React from 'react';
import { Components } from './styled';
import { ReactComponent as ThreeDotsIcon } from '../../../../assets/icons/icon-three-dots.svg';
import useDropdown from '../../../../hooks/useDropdown';
import ProjectDropdown from '../../../../components/ProjectDropdown';
import { Section } from '../../../../api/appConfiguration/types';

const AdditionalActions = ({
  itemKey,
  section,
  onEdit,
  onMoveUp,
  onMoveDown,
  onDelete,
}: {
  itemKey: string;
  section: Section;
  onEdit?: (id: string, section: Section) => void;
  onMoveUp?: (id: string) => void;
  onMoveDown?: (id: string) => void;
  onDelete?: (id: string) => void;
}) => {
  const dropdownProps = useDropdown();

  const _onEdit = () => {
    onEdit?.(itemKey, section);
  };

  const _onMoveUp = async () => {
    onMoveUp?.(itemKey);
  };

  const _onMoveDown = async () => {
    onMoveDown?.(itemKey);
  };
  const _onDelete = async () => {
    onDelete?.(itemKey);
  };

  return (
    <Components.Container fullHeight displayFlex alignItems={'center'} justifyContent={'center'}>
      <Components.Button onClick={dropdownProps.show} aria-expanded={dropdownProps.open ? 'true' : undefined}>
        <ThreeDotsIcon />
      </Components.Button>
      <ProjectDropdown
        {...dropdownProps}
        onEdit={onEdit ? _onEdit : undefined}
        onMoveUp={onMoveUp ? _onMoveUp : undefined}
        onMoveDown={onMoveDown ? _onMoveDown : undefined}
        onDelete={onDelete ? _onDelete : undefined}
      />
    </Components.Container>
  );
};

export default AdditionalActions;
